"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleItem = exports.StyledSwitchWrapper = exports.StyledInputWrapper = exports.StyledInputCompanyWrapper = exports.StyledTitleWrapper = exports.StyledIndustryNameWrapper = exports.StyledOptionalWrapper = exports.StyledChildrenContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const AiImageStyles_style_1 = require("../AiImage/AiImageStyles.style");
exports.StyledChildrenContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  ${({ theme }) => (0, styled_components_1.css) `
    gap: ${ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
    margin-bottom: ${ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
  `}
`;
exports.StyledOptionalWrapper = styled_components_1.default.span `
  display: inline-flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledIndustryNameWrapper = styled_components_1.default.span `
  display: flex;
  ${({ theme }) => (0, styled_components_1.css) `
    gap: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
    padding: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)}
      ${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
    border-radius: ${ui_common_components_1.utils.rem(theme.Border.Radius.Small)};

    &:hover {
      background: ${theme.Color.System.Primary};
    }
  `}
`;
exports.StyledTitleWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
`;
exports.StyledInputCompanyWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;

  &&& input {
    padding-right: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXXLarge)};
  }
`;
exports.StyledInputWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
  flex-direction: column;
`;
exports.StyledSwitchWrapper = styled_components_1.default.span `
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  bottom: 0;
  height: ${({ theme }) => ui_common_components_1.utils.rem(theme.Form.InputSize.Medium.height)};

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${`0  ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
    border-left: ${`${ui_common_components_1.utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border}`};
  `}
`;
exports.StyleItem = styled_components_1.default.a `
  display: flex;
  align-items: center;
  flex-flow: column;
  text-align: center;
  transition: all ${({ theme }) => theme.Transition.Timing.out};

  span {
    color: ${({ theme }) => theme.Color.Neutrals.Dark};
    transition: all ${({ theme }) => theme.Transition.Timing.out};
  }

  ${({ selected }) => selected &&
    (0, styled_components_1.css) `
      ${AiImageStyles_style_1.StyleImageWrapper} {
        box-shadow: inset 0 0 0 1.5px
          ${({ theme }) => theme.Color.Brand.Primary};
      }

      span {
        color: ${({ theme }) => theme.Color.Brand.Primary};
      }

      svg {
        fill: ${({ theme }) => theme.Color.Brand.Primary};
      }
    `}
  &:hover {
    transition: all ${({ theme }) => theme.Transition.Timing.in};

    cursor: pointer;
    ${({ theme }) => (0, styled_components_1.css) `
      ${AiImageStyles_style_1.StyleImageWrapper} {
        box-shadow: inset 0 0 0 1.5px ${theme.Color.Brand.Primary};
      }

      span {
        color: ${({ theme }) => theme.Color.Brand.Primary};
      }

      svg {
        fill: ${({ theme }) => theme.Color.Brand.Primary};
      }
    `}
  }
`;
//# sourceMappingURL=AiLogoStyles.style.js.map